import styles from "./CitySelector.module.css";

const CitySelector = ({
  hotels = [],
  selectedState,
  selectedCity,
  onCityChange,
}) => {
  const cities = [
    ...new Set(
      hotels
        .filter((hotel) =>
          selectedState ? hotel.state === selectedState : true
        )
        .map((hotel) => hotel.city)
        .filter(Boolean)
    ),
  ].sort((a, b) => a.localeCompare(b));

  return (
    <div className={styles.container}>
      <label className={styles.label}>
        Select City
      </label>

      <select
        className={styles.select}
        value={selectedCity}
        onChange={(e) => onCityChange(e.target.value)}
      >
        <option value="">Select City</option>

        {cities.map((city) => (
          <option key={city} value={city}>
            {city}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CitySelector;